import LangSwitcher from '@/components/LangSwitcher';
import store from '@/store';
import i18n from '@/i18n';

const redirectToErrorPage = (to, from, next, err) => {
    store.commit('SET_APP_LOADING', false);
    if (to.params.id) {
        next({
            name: 'DocumentError',
            replace: true,
            params: {
                lang: to.params.lang,
                text: err.message ? err.message : ''
            }
        });
    } else {
        next({
            name: 'DocumentError',
            replace: true,
            params: {
                lang: to.params.lang,
                text: 'Открыть поиск'
            }
        });
    }
};

const fetchGeneralInfo = async (to, from, next) => {
    if (to.params.id) {
        try {
            return await store.dispatch('fetchGeneralInfoById', to.params.id);
        } catch (err) {
            redirectToErrorPage(to, from, next, err);
        }
    }
    store.dispatch('fetchGeneralInfoById', to.params.id);
    redirectToErrorPage(to, from, next);
    return false;
};

const fetchDocInfo = async (to, from, next) => {
    try {
        await store.dispatch('fetchDocumentInfo', to.params.id);
        if (!store.getters.getGeneralInfo.isAvailable) {
            document.location.href = `https://viewer.rusneb.ru/${to.params.lang}/000199_000009_${to.params.id}`;
        } else if (!store.getters.getGeneralInfo.isOpen && !store.getters.getGeneralInfo.isLogin) {
            /*  если документ находится в ограниченном просмотре и пользователя не залогинен
            *   или если документ не доступен для пользователя, редирект на enter.
            */
            store.commit('SET_APP_LOADING', false);
            next({
                name: 'Enter',
                replace: true,
                params: {
                    lang: to.params.lang,
                    id: to.params.id
                },
                query: {
                    ...to.query
                }
            });
        } else {
            store.commit('SET_APP_LOADING', false);
            next();
        }
    } catch (err) {
        redirectToErrorPage(to, from, next, err);
    }
};

const initApp = async (to, from, next) => {
    if (store.getters.isAppLoading) {
        /* фетч данных независимо от страницы. например аутентификация */
        await fetchGeneralInfo(to, from, next);
    }
    if (to.name === 'DocumentError') {
        if (store.getters.isAppLoading) {
            store.commit('SET_APP_LOADING', false);
        }
        next();
    } else if (store.getters.isAppLoading) {
        await fetchDocInfo(to, from, next);
    } else {
        next();
    }
};

const presetDocument = async (to, from, next) => {
    if (!store.getters.isDocumentPageDataLoaded) {
        await Promise.all([
            store.dispatch('fetchDocumentPagesById', to.params.id),
            store.dispatch('checkDocumentHasTextSearch', to.params.id)
        ]);
        store.commit('SET_DOCUMENT_PAGE_DATA_LOADED', true);
        next();
    } else {
        next();
    }
};

const routes = [
    {
        path: '*',
        name: 'MainViewApp',
        redirect: `/${i18n.locale}/`
    },
    {
        path: '/:lang',
        component: LangSwitcher,
        beforeEnter: initApp,
        children: [
            {
                path: '',
                name: 'DocumentError',
                component: () => import(/* webpackChunkName: "Document" */ '@/pages/Document.vue')
            },
            {
                path: ':id',
                name: 'Enter',
                component: () => import(/* webpackChunkName: "Enter" */ '@/pages/Enter.vue')
            },
            {
                path: 'viewer/:id',
                name: 'Document',
                component: () => import(/* webpackChunkName: "Document" */ '@/pages/Document.vue'),
                beforeEnter: presetDocument
            }
        ]
    }
];

export default routes;
